import { render, staticRenderFns } from "./TxRowActionBadgeMobile.vue?vue&type=template&id=97bb9c0c"
import script from "./TxRowActionBadgeMobile.vue?vue&type=script&lang=js"
export * from "./TxRowActionBadgeMobile.vue?vue&type=script&lang=js"
import style0 from "./TxRowActionBadgeMobile.vue?vue&type=style&index=0&id=97bb9c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports